import React from "react";

function Footer() {
  return (
    <>
      {/* Footer */}
      <footer className="footerBackgroundColor sticky-footer bg-white">
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <div>Support: piggymate.help@gmail.com</div>
            <span>Copyright PiggyMate &copy; {new Date().getFullYear()}</span>
          </div>
        </div>
      </footer>
      {/* End of Footer */}
    </>
  );
}

export default Footer;
